import axios from '@axios'

const PREFIX = '/usuarios-externos'

export default {

  getEmpresasUsuario(filtro) {
    return axios.post(`${PREFIX}/empresas`, filtro)
  },
}
